module.exports = __webpack_public_path__ + "img/logo_trillion.b1a9c485.png";